import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function FooterInfo(props) {
  const {
    currentStep,
    currentVariant,
    strings,
  } = useContext(ConfiguratorContext)

  const defaultFooterInfo = strings.footer?.info ?? ''
  const steps = currentVariant.steps ?? {}
  let footerInfo = typeof steps?.[currentStep]?.subtitle === 'string' && steps?.[currentStep]?.subtitle.length > 0
    ? steps?.[currentStep]?.subtitle
    : typeof steps?.[1]?.subtitle === 'string' && steps?.[1]?.subtitle.length > 0
      ? steps?.[1]?.subtitle
      : defaultFooterInfo

  return (
    <div
      className='config-overview-bar__field config-overview-bar__field--delivery-text'
      dangerouslySetInnerHTML={{ __html: footerInfo }}
    />
  )
}
